import React from 'react';
import { Manager, Reference, Popper } from 'react-popper';
import { Button, UncontrolledTooltip } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import Icon from '../../Icon/Icon';
import ExportStatisticsModal from '../../../modals/ExportStatisticsModal/ExportStatisticsModal';

const View = ({
  open,
  exportFields,
  $el,
  toggle,
  handleExportXLS,
  handleExportXML,
  handleExportCSV,
}) => (
  <Manager>
    <div className="statistics-export" ref={$el}>
      <Reference>
        {({ ref }) => (
          <button
            id="statistics-filters-addons-export"
            ref={ref}
            className="statistics-mini-button statistics-mini-button--export"
            onClick={toggle}
          >
            <Icon type="download" />
          </button>
        )}
      </Reference>
      <UncontrolledTooltip placement="top" target="statistics-filters-addons-export">
        <FormattedMessage
          id="statistics.filters.addons.export.tooltip"
          defaultMessage="Export statistics with selected filters"
        />
      </UncontrolledTooltip>

      {open && (
        <ExportStatisticsModal
          isOpen={open}
          handleExportXLS={handleExportXLS}
          handleExportXML={handleExportXML}
          handleExportCSV={handleExportCSV}
          exportFields={exportFields}
          handleClose={toggle}
        />
      )}
      {/* {open && (
        <Popper placement="bottom">
          {({ ref, style, placement, arrowProps }) => (
            <div
              className="statistics-bubble statistics-export-container popover"
              ref={ref}
              style={style}
              data-placement={placement}
            >
              <div className="statistics-bubble-header statistics-export-header popover-header">
                <FormattedMessage id="statistics.export.title" defaultMessage="Export" />
                <Icon type="cross-rounded" className="statistics-bubble-close" onClick={close} />
              </div>

              <div className="statistics-bubble-body popover-body">
                <div className="statistics-export-controls">
                  <Button color="primary" size="sm" onClick={handleExportXLS}>
                    XLS
                  </Button>
                  <Button color="primary" size="sm" onClick={handleExportXML}>
                    XML
                  </Button>
                  <Button color="primary" size="sm" onClick={handleExportCSV}>
                    CSV
                  </Button>
                </div>
                {exportFields}
              </div>
              <span className="arrow" ref={arrowProps.ref} style={arrowProps.style} />
            </div>
          )}
        </Popper>
      )} */}
    </div>
  </Manager>
);

export default View;
